<template>
  <div class="contentBox">
    <div :class="['mainTopMsgs', mainTopMsgsOpen]">
      <div class="bottom">
        <span v-for="(name, index) in breadcrumbList" :key="name">
          <span class="separator" v-if="index">/</span>
          <span :class="[index == breadcrumbList.length - 1 ? 'last' : '']">{{
              name
          }}</span>
        </span>
      </div>
    </div>
    <div class="routerBox">
      <div class="view">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keepAlive: false,
    };
  },
  computed: {
    mainTopMsgsOpen() {
      const open = !["Home"].includes(this.$route.name);
      return open ? "open" : "close";
    },
    breadcrumbList() {
      const matched = this.$route.matched
        .map((a) => a.meta.name)
        .filter((a) => Boolean(a));
      return matched;
    },
  },
};
</script>
<style lang="scss" scoped>
.contentBox {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.mainTopMsgs {
  width: 100%;
  overflow: hidden;
  transition: height 0.3s;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  user-select: none;

  &.open {
    height: 30px;
    margin-bottom: 10px;
  }

  &.close {
    height: 0;
    margin-bottom: $layout_margin;

    .bottom {
      bottom: 20px;
    }
  }

  .bottom {
    position: absolute;
    left: $layout_margin;
    bottom: 0;
    transition: 0.3s;
    font-size: 14px;
    color: $default_color;
    font-weight: 500;

    .separator {
      margin: 0 3px;
    }

    .last {
      color: $form_label_color;
    }
  }
}

.routerBox {
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  padding-left: $layout_margin;
  padding-right: $layout_margin;
  padding-bottom: $layout_margin;
  overflow: hidden;

  .view {
    border-radius: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }
}
</style>
